<div
  class="offcanvas offcanvas-start"
  tabindex="-1"
  id="chooseAgentOffcanvas"
  aria-labelledby="chooseAgentOffcanvasLabel"
>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="chooseAgentOffcanvasLabel">Choose Agent</h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body p-0" #elementScroll>
    <div class="box-input border-bottom">
      <div class="input-icon">
        <input
          type="text"
          class="form-control"
          placeholder="Search agent..."
          [(ngModel)]="filterText"
          (ngModelChange)="onFilterTextChange()"
        />
        <a
          class="icon-button"
          pTooltip="Reset"
          (click)="onResetFilter()"
          *ngIf="filterText.length > 0"
        >
          <i class="bi bi-x-lg"></i>
        </a>
      </div>

      <div class="hstack gap-2 justify-content-end">
        <a
          pTooltip="case sensitive"
          class="filter-option"
          [class.active]="filterOptions.caseSensitive === true"
          (click)="
            filterOptions.caseSensitive = !filterOptions.caseSensitive; onFilterOptionsChange()
          "
        >
          Aa
        </a>
        <a
          pTooltip="match from start"
          class="filter-option"
          [class.active]="filterOptions.matchFromStart"
          (click)="
            filterOptions.matchFromStart = !filterOptions.matchFromStart; onFilterOptionsChange()
          "
        >
          <span class="text-decoration-underline">ab</span>c
        </a>
        <a
          pTooltip="equals"
          class="filter-option"
          [class.active]="filterOptions.equals"
          (click)="filterOptions.equals = !filterOptions.equals; onFilterOptionsChange()"
        >
          <span class="text-decoration-underline">ab</span>
        </a>
      </div>
    </div>
    <div class="agent-list">
      <div *ngIf="agentLoading" class="py-3 text-center">
        <div class="spinner-border spinner-border-sm"></div>
      </div>
      <div *ngIf="!agentLoading && agentItems.length === 0" class="py-3 text-center">
        {{ "NO_DATA_FOUND" | translate }}
      </div>
      <a
        *ngFor="let item of agentItems; trackBy: trackByAgent"
        class="agent-item"
        [class.active]="selectedAgent?.id === item.id"
        id="agent-item-{{ item.id }}-{{ item.agent_code }}"
        (click)="onSelectAgent(item)"
      >
        <div class="hstack gap-2">
          <span class="opacity-75">{{ "USERNAME" | translate }}:</span>
          <span [innerHTML]="item.agent_name_highlighted"></span>
        </div>
        <div class="hstack gap-2">
          <span class="opacity-75">{{ "NAME" | translate }}:</span>
          <span [innerHTML]="item.agent_contact_name_highlighted"></span>
        </div>
        <div class="hstack gap-2">
          <span class="opacity-75">{{ "TYPE" | translate }}:</span>
          <span>{{ item.typeDetail || "-" }}</span>
        </div>
        <div class="hstack gap-2">
          <span class="opacity-75">{{ "CREDIT" | translate }} :</span>
          <span>{{ item.credit_remaining || 0 | number : "0.2-2" }}</span>
        </div>
      </a>
    </div>
    <div class="box-button border-top">
      <button
        type="button"
        class="btn btn-primary w-100"
        (click)="onSubmit()"
        [disabled]="!selectedAgent || agentLoading"
      >
        {{ "SAVE_DATA" | translate }}
      </button>
    </div>
  </div>
</div>
